import {
  CREATE_CONTACT_SUCCESS,
  CREATE_CONTACT_FAIL,
  RETRIEVE_CONTACT_SUCCESS,
  RETRIEVE_CONTACT_FAIL,
  UPDATE_CONTACT_SUCCESS,
  UPDATE_CONTACT_FAIL,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_CONTACT_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_CONTACT_SUCCESS:
      return payload;

    case RETRIEVE_CONTACT_FAIL:
      return [...datas];

    case UPDATE_CONTACT_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_CONTACT_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
